import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderField, required } from '../../utils/formValidation';

import '../../components/inputs/input.css';
import '../../components/inputs/Textbox/index.css';
import '../form.css';

const ChangeDefaultPasswordForm = props => {
  const { handleSubmit } = props;
  return (
    <form className="newCompanyForm" onSubmit={handleSubmit}>
      <div className="form-fields">
        <Field
          name="new_default_password"
          component={renderField}
          label="New Default User Password"
          validate={[required]}
          placeholder={''}
          requiredLabel={true}
        />
        <Field
          name="confirm_default_password"
          component={renderField}
          label="Confirm New User Default Password"
          validate={[required]}
          placeholder={''}
          requiredLabel={true}
        />
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'ChangeDefaultPasswordForm'
})(ChangeDefaultPasswordForm);
